import PropTypes from 'prop-types';
import React from 'react';
import loaderDotImg from '../../../styles/images/dots-loading-black.gif';
import loaderSpinImg from '../../../styles/images/spinner-loader.gif';
import './loading.scss';

const LoaderTypes = {
  SPINNER: 'spinner',
  DOTS: 'dots',
};

const Loading = ({ loaderType }) => {
  if (loaderType === LoaderTypes.SPINNER) {
    return (
      <div className="spinner-loader">
        <img src={loaderSpinImg} width={40} height={40} alt="loader" />
      </div>
    );
  }

  return (
    <div className="loading-cont">
      <div className="dot-loader">
        <img src={loaderDotImg} width={40} height={40} alt="test" />
      </div>
    </div>
  );
};

Loading.defaultProps = {
  loaderType: LoaderTypes.DOTS,
};

Loading.propTypes = {
  loaderType: PropTypes.oneOf([...Object.values(LoaderTypes)]),
};

export {
  Loading as default,
  LoaderTypes,
};
